import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {MedicalOrganizationManagementFeature} from "../../features/medicalOrganizationManagement";

const ALLOWED_PERMISSION = 'medicalOrganizationManagement'

const MedicalOrganizationManagementPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <MedicalOrganizationManagementFeature
      userToken={userToken}
    />
  </PermissionGuard>
)

export default MedicalOrganizationManagementPage